import { Injectable } from '@angular/core';
import { gql } from 'apollo-angular';

import { ApiMutation } from '../../../../common/model/api.mutation';
import { user } from '../model/user.fragments';
import { UserOutput } from '../model/user.output';

export interface UpdateUserQuoteParams {
	readonly quote: string;
}

@Injectable({ providedIn: 'root' })
export class UpdateUserQuoteApiMutation extends ApiMutation<
	UserOutput,
	UpdateUserQuoteParams
> {
	client = 'iam';
	document = gql`
		mutation UpdateUserQuote($quote: String!) {
			updateUserQuote(quote: $quote) {
				...User
			}
		}
		${user}
	`;
	method = 'updateUserQuote';
}
